/**
 * Authors: mariushirjanu, koenweyn
 * Created: 02/05/2021
 */
import { Component, Input } from '@angular/core';
import { IFaqItem } from './faq-list.component';
import { AuthService } from '@app/shared/services/auth/auth.service';
import { STATE_FAQ, STATE_FAQ_EDIT } from '@app/shared/app-states';

@Component({
  selector: 'faq-list-content',
  template:
    `
      <div class="faq-answer" [innerHTML]="faq.answer" [scrollTarget]="faq.scrollTarget"></div>
      <div *ngIf="acslUser" class="faq-edit-link">
        <a href class="btn btn-default" uiSref="${STATE_FAQ_EDIT}" [uiParams]="{ key: faq.id }" target="_blank"><i class="fa fa-pencil"></i> Edit</a>
      </div>
      <div *ngFor="let attachment of faq.attachments; trackById">
        <i class="fa fa-paperclip"></i>&nbsp;<a [href]="attachment.value" target="_blank">{{attachment.id}}</a>
      </div>
      <a *ngIf="faq.confluencePageHtml" uiSref="${STATE_FAQ}" [uiParams]="{key: faq.id}" target="_blank">More</a>
    `
})
export class FaqListContentComponent {
  @Input() public faq:IFaqItem;

  public acslUser:boolean;

  constructor(
    authService:AuthService
  ) {
    this.acslUser = authService.checkAcslUser();
  }
}